import { TrendingUp, AlertTriangle, Zap, Activity, Target, Lightbulb } from "lucide-react";

const AICrowdDynamics = () => {
  return (
    <div className="min-h-screen bg-[#f8f9fa] p-8">
      <div className="max-w-7xl mx-auto">

        {/* Report Title */}
        <div className="mb-8">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-1">
              AI Crowd Dynamics Report
              </h1>
              <p className="text-sm text-gray-600">
              Jan 6, 2025 | 08:45 PM - Jan 12, 2025 | 04:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* First Row - Three Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {/* Top 5 Congested Zones */}
          <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center">
                <AlertTriangle className="w-4 h-4 text-red-500" />
              </div>
              <h3 className="font-semibold text-[#1a1a1a]">Top 5 Congested Zones</h3>
            </div>
            <div className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-[#6b7280] font-medium">High Density</span>
              </div>
              <div className="space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-[#1a1a1a]">Gate Gate</span>
                  <div className="w-2 h-2 rounded-full bg-red-500"></div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-[#1a1a1a]">Marketplace Parking</span>
                  <div className="w-2 h-2 rounded-full bg-red-500"></div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-[#1a1a1a]">Prayer-hall Area</span>
                  <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                </div>
              </div>
            </div>
          </div>

          {/* AI Forecast */}
          <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center">
                <TrendingUp className="w-4 h-4 text-blue-500" />
              </div>
              <h3 className="font-semibold text-[#1a1a1a]">AI Forecast</h3>
            </div>
            <div className="text-sm text-[#6b7280] mb-4">Next 30 minutes</div>
            <div className="space-y-4">
              <div className="p-4 bg-red-50 rounded-lg border border-red-200">
                <div className="flex items-start gap-2">
                  <div className="mt-1">
                    <AlertTriangle className="w-4 h-4 text-red-500" />
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-red-600 mb-1">97%</div>
                    <div className="text-xs text-[#6b7280]">chance of congestion</div>
                    <div className="text-xs text-[#1a1a1a] mt-1">at Gate 5 & Main Hall (5:30 PM–6:00 PM)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* AI Suggested Actions */}
          <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center">
                <Zap className="w-4 h-4 text-purple-500" />
              </div>
              <h3 className="font-semibold text-[#1a1a1a]">AI Suggested Actions</h3>
            </div>
            <div className="text-sm text-[#6b7280] mb-4">Real-time data-driven recommendations</div>
            <div className="space-y-2">
              <div className="flex items-start gap-2 text-sm">
                <span className="text-[#1a1a1a]">•</span>
                <span className="text-[#1a1a1a]">Open Auxiliary exits by 2:00 P.M</span>
              </div>
              <div className="flex items-start gap-2 text-sm">
                <span className="text-[#1a1a1a]">•</span>
                <span className="text-[#1a1a1a]">Focus live video of by 50 mins</span>
              </div>
              <div className="flex items-start gap-2 text-sm">
                <span className="text-[#1a1a1a]">•</span>
                <span className="text-[#1a1a1a]">Increase QR Gate frequency in final density areas</span>
              </div>
            </div>
          </div>
        </div>

        {/* Second Row - Two Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Dynamic Heatmap */}
          <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-orange-50 flex items-center justify-center">
                <Activity className="w-4 h-4 text-orange-500" />
              </div>
              <h3 className="font-semibold text-[#1a1a1a]">Dynamic Heatmap</h3>
            </div>
            <div className="text-sm text-[#6b7280] mb-4">Visualizing High Zone</div>
            <div className="flex gap-2 mb-6">
              <button className="px-4 py-2 text-sm border border-[#e5e7eb] rounded-lg bg-white hover:bg-gray-50">
                Sao Mari
              </button>
              <button className="px-4 py-2 text-sm border border-[#e5e7eb] rounded-lg bg-white hover:bg-gray-50">
                Purvey
              </button>
              <button className="px-4 py-2 text-sm border border-[#e5e7eb] rounded-lg bg-white hover:bg-gray-50">
                Tirupathan
              </button>
              <button className="px-4 py-2 text-sm border border-[#e5e7eb] rounded-lg bg-white hover:bg-gray-50">
                Srienna
              </button>
            </div>
            <div className="h-32 bg-gradient-to-r from-green-100 via-yellow-100 to-red-100 rounded-lg mb-4"></div>
            <div className="flex justify-between text-xs text-[#6b7280]">
              <span>0 / Clear (60)</span>
              <span>2 min</span>
            </div>
          </div>

          {/* ETK Comparison */}
          <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center">
                <Target className="w-4 h-4 text-green-600" />
              </div>
              <h3 className="font-semibold text-[#1a1a1a]">ETK Comparison</h3>
            </div>
            <div className="text-sm text-[#6b7280] mb-4">Queue vs. AI Kiosk (Last 60 days)</div>
            <div className="flex items-end justify-center gap-3 h-48 mb-4">
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '85%' }}></div>
                <span className="text-xs text-[#6b7280]">Mon</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '75%' }}></div>
                <span className="text-xs text-[#6b7280]">Tue</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '65%' }}></div>
                <span className="text-xs text-[#6b7280]">Wed</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '70%' }}></div>
                <span className="text-xs text-[#6b7280]">Thu</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '68%' }}></div>
                <span className="text-xs text-[#6b7280]">Fri</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '60%' }}></div>
                <span className="text-xs text-[#6b7280]">Sat</span>
              </div>
              <div className="flex flex-col items-center gap-1">
                <div className="w-12 bg-black rounded-t" style={{ height: '50%' }}></div>
                <span className="text-xs text-[#6b7280]">Sun</span>
              </div>
            </div>
            <div className="flex justify-center gap-6 text-xs">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-black rounded"></div>
                <span className="text-[#6b7280]">Queue</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-gray-300 rounded"></div>
                <span className="text-[#6b7280]">Kiosk</span>
              </div>
            </div>
          </div>
        </div>

        {/* Feedback Intelligence Report */}
        <div className="mb-8">
          <h2 className="text-xl font-bold text-[#1a1a1a] mb-1">Feedback Intelligence Report</h2>
          <p className="text-sm text-[#6b7280] mb-6">Discover trends from AI-Managed Feedback</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Feedback Categories */}
            <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
              <h3 className="font-semibold text-[#1a1a1a] mb-4">Feedback Categories</h3>
              <div className="text-sm text-[#6b7280] mb-6">AI-categorized feedback distribution</div>
              <div className="flex justify-center mb-6">
                <div className="relative w-48 h-48">
                  <svg viewBox="0 0 200 200" className="w-full h-full">
                    <circle cx="100" cy="100" r="90" fill="#8b5cf6" opacity="0.8" />
                  </svg>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 text-xs">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-[#8b5cf6]"></div>
                  <span className="text-[#6b7280]">Positive</span>
                  <span className="ml-auto font-semibold">60%</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-[#3b82f6]"></div>
                  <span className="text-[#6b7280]">Neutral</span>
                  <span className="ml-auto font-semibold">20%</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-[#10b981]"></div>
                  <span className="text-[#6b7280]">Suggestion/Interesting</span>
                  <span className="ml-auto font-semibold">10%</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 rounded-full bg-[#f59e0b]"></div>
                  <span className="text-[#6b7280]">Negative</span>
                  <span className="ml-auto font-semibold">10%</span>
                </div>
              </div>
            </div>

            {/* Sentiment Analysis */}
            <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
              <h3 className="font-semibold text-[#1a1a1a] mb-4">Sentiment Analysis</h3>
              <div className="text-sm text-[#6b7280] mb-6">Real-time mood & sentiment tracking</div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-[#e5e7eb]">
                      <th className="text-left py-3 font-semibold text-[#1a1a1a]">Sentiments</th>
                      <th className="text-left py-3 font-semibold text-[#1a1a1a]">Volume</th>
                      <th className="text-left py-3 font-semibold text-[#1a1a1a]">Trend</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-[#e5e7eb]">
                      <td className="py-3 flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                        <span className="text-[#1a1a1a]">Positive</span>
                      </td>
                      <td className="py-3 text-[#1a1a1a]">25</td>
                      <td className="py-3 text-green-600 flex items-center gap-1">
                        <TrendingUp className="w-3 h-3" />
                        <span className="text-xs">Increasing</span>
                      </td>
                    </tr>
                    <tr className="border-b border-[#e5e7eb]">
                      <td className="py-3 flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-yellow-500"></div>
                        <span className="text-[#1a1a1a]">Neutral</span>
                      </td>
                      <td className="py-3 text-[#1a1a1a]">5</td>
                      <td className="py-3 text-[#6b7280] text-xs">Stable</td>
                    </tr>
                    <tr>
                      <td className="py-3 flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-red-500"></div>
                        <span className="text-[#1a1a1a]">Negative</span>
                      </td>
                      <td className="py-3 text-[#1a1a1a]">10</td>
                      <td className="py-3 text-red-600 flex items-center gap-1">
                        <TrendingUp className="w-3 h-3 rotate-180" />
                        <span className="text-xs">Decreasing</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                <p className="text-xs text-[#6b7280]">
                  <span className="font-semibold">Ideal Feedback:</span> AI recommend 3 new AI-ready
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* AI Summary & Insights */}
        <div className="bg-white rounded-lg border border-[#e5e7eb] p-6 mb-8">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full bg-yellow-50 flex items-center justify-center">
              <Lightbulb className="w-4 h-4 text-yellow-600" />
            </div>
            <h3 className="font-semibold text-[#1a1a1a]">AI Summary & Insights</h3>
          </div>
          <div className="space-y-2 text-sm text-[#1a1a1a]">
            <div className="flex items-start gap-2">
              <span className="mt-1">✓</span>
              <span>Continuous optimization improving safe, fast and efficient ticketing</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="mt-1">✓</span>
              <span>Power congestion consistent wait Gates 5—probably malfunctioned kiosk</span>
            </div>
          </div>
        </div>

        {/* AI Command Suggestions */}
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center">
              <Zap className="w-4 h-4 text-purple-500" />
            </div>
            <h3 className="text-xl font-bold text-[#1a1a1a]">AI Command Suggestions</h3>
          </div>
          <p className="text-sm text-[#6b7280] mb-6">AI-generated suggestions based on real-time data</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Suggestion 1 */}
            <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                  <Target className="w-5 h-5 text-gray-600" />
                </div>
                <span className="text-xs text-[#6b7280]">High</span>
              </div>
              <h4 className="font-semibold text-[#1a1a1a] mb-2">Auto-generate alert for Bharatha Zone</h4>
              <p className="text-sm text-[#6b7280] mb-4">
                Send immediate notification to staff at Bharatha Zone
              </p>
              <button className="w-full py-2 bg-black text-white text-sm rounded-lg hover:bg-gray-800 transition-colors">
                Generate Alert
              </button>
            </div>

            {/* Suggestion 2 */}
            <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                  <AlertTriangle className="w-5 h-5 text-gray-600" />
                </div>
                <span className="text-xs text-[#6b7280]">medium</span>
              </div>
              <h4 className="font-semibold text-[#1a1a1a] mb-2">Predict queue time change (+30%) after direction</h4>
              <p className="text-sm text-[#6b7280] mb-4">
                Expected improvement based on latest data 5:00-6:30 pm
              </p>
              <button className="w-full py-2 bg-black text-white text-sm rounded-lg hover:bg-gray-800 transition-colors">
                View Prediction
              </button>
            </div>

            {/* Suggestion 3 */}
            <div className="bg-white rounded-lg border border-[#e5e7eb] p-6">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
                  <Activity className="w-5 h-5 text-gray-600" />
                </div>
                <span className="text-xs text-[#6b7280]">medium</span>
              </div>
              <h4 className="font-semibold text-[#1a1a1a] mb-2">Smart schedule triggers clearing more dispatch</h4>
              <p className="text-sm text-[#6b7280] mb-4">
                Review additional personnel from other Center
              </p>
              <button className="w-full py-2 bg-black text-white text-sm rounded-lg hover:bg-gray-800 transition-colors">
                Review Plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AICrowdDynamics;
